import PageLoadedQueue from "../PageLoadedQueue";

class FormJsSubmit {

    protected form: HTMLFormElement;
    protected formSubmitButton: HTMLButtonElement;
    protected formAction: string;
    protected formIdentifier: string;

    constructor(form: HTMLFormElement) {
        // set variables
        this.form = form;
        this.formSubmitButton = form.querySelector('[type="submit"]');
        this.formAction = form.getAttribute('action');
        this.formIdentifier = form.getAttribute('id');

        // bind listener callbacks
        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        // init listeners
        this.initializeListeners();
    }

    protected initializeListeners = () => {
        this.form.addEventListener('submit', this.handleFormSubmit);
    }

    protected handleFormSubmit = (e:Event) => {
        e.preventDefault();
        const formData = new FormData(this.form);
        if (this.formSubmitButton) {
            formData.append(this.formSubmitButton.name, this.formSubmitButton.value);
        }

        formData.append('jsSubmit', true);
        this.formSubmitButton.classList.add('disabled');

        fetch(this.formAction, {
            method: 'POST',
            body: formData
        }).then(response => {
            if (response.redirected) {
                // handle redirect
                const url = new URL(response.url);
                url.searchParams.delete('jsSubmit');
                window.location.href = url.toString();
                return;
            }
            if (!response.ok) {
                throw new Error(`Fehler: ${response.statusText}`);
            }
            return response.text();
        }).then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const formElement = doc.getElementById(this.formIdentifier) as HTMLFormElement;

            // destroy old form instance before swapping out html
            this.destroy();

            // swap html
            this.form.parentNode?.replaceChild(formElement, this.form);

            // create new form submit instance
            new FormJsSubmit(formElement);

            const htmlChangedEvent = new CustomEvent('plandent.html.changed', {detail:{target:formElement}});
            document.dispatchEvent(htmlChangedEvent);

        }).catch(error => {
            console.log('Fehler beim Senden des Formulars:', error);
        });
    }

    destroy() {
        this.form.removeEventListener('submit', this.handleFormSubmit);
    }

    static initializedElements:Map<HTMLElement, FormJsSubmit> = new Map();

    static initialize() {
        FormJsSubmit.checkElements();
        document.addEventListener('plandent.html.changed', (e) => {
            FormJsSubmit.checkElements();
        });
    }
    static checkElements() {
        // check for forms with enabled js submit or ANY form within contentpopup
        document.querySelectorAll('form[data-js-submit="1"], .content-popup form[data-js-submit]').forEach((form: HTMLFormElement) => {
            if(!FormJsSubmit.initializedElements.has(form)) {
                FormJsSubmit.initializedElements.set(form, new FormJsSubmit(form));
            }
        });
    }
}
PageLoadedQueue.addFunction(FormJsSubmit.initialize);
